var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"mx-auto",attrs:{"src":_vm.logo,"alt":"logo régie","contain":"","eager":"","max-width":"650"}})}
var staticRenderFns = []

export { render, staticRenderFns }